module.exports = __webpack_public_path__ + "img/bj41.f11d48c5.png";